import { z } from 'zod';
const EMAIL_REGEX = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
export const emailSchema = z
    .string()
    .refine((val) => EMAIL_REGEX.test(val), {
    message: 'Invalid email address',
})
    .meta({ autocomplete: 'email' });
/** Optional email that treats CRM empty strings as absent. */
export const optionalEmailSchema = z.preprocess((val) => (typeof val === 'string' && val.trim() === '' ? undefined : val), z.email().optional());
/**
 * Shared conditional email validation for use inside `superRefine`, mirroring
 * `validatePhone` in ./phone-number. By default the email is required; pass
 * `requiredWhen: false` (e.g. an unchecked "send invite" box) to skip it
 * entirely. Format checks delegate to `emailSchema` so every caller agrees on
 * what a valid address looks like.
 */
export const validateEmail = (ctx, fieldName, email, options) => {
    if (options?.requiredWhen === false)
        return;
    const value = email?.trim();
    if (!value) {
        ctx.addIssue({ code: 'custom', path: [fieldName], message: 'Email is required' });
        return;
    }
    if (!emailSchema.safeParse(value).success) {
        ctx.addIssue({ code: 'custom', path: [fieldName], message: 'Please enter a valid email' });
    }
};
